import {Component, OnDestroy, OnInit} from '@angular/core';
import {OcrService} from '../../../components/ocr/ocr.service';
import {OcrFileinfo, WorkHistoryEntry, EducationEntry} from '../../../domain/model/common/file/ocr-file-info.class';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {CountryService} from '../../../domain/model/info/country/country.service';
import {Observable} from 'rxjs';

@Component({
    template: require('./files-view-page.component.html'),
    styles: [require('./files-view-page.component.scss')],
})
export class FilesViewPageComponent implements OnInit, OnDestroy {
    file: OcrFileinfo;
    content: string;
    public loading: boolean = false;
    public id: string;
    public workEntries: WorkHistoryEntry[];
    public educationEntries: EducationEntry[];
    private sub: any;
    private subRouter: any;

    constructor(protected ocrService: OcrService,
                readonly route: ActivatedRoute,
                protected countryService: CountryService,
                private readonly _router: Router
                ) {}

    ngOnInit(): void {
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });
        this.subRouter = this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.loadContent(this.id);
            }
        });
    }

    loadContent(id: string) {
        this.loading = true;
        Observable.forkJoin(
            this.ocrService.file(id),
            this.ocrService.fileContent(id)
        ).subscribe(
            results => {
                this.file = results[0];
                this.workEntries = this.file.parsingData.workHistory;
                this.educationEntries = this.file.parsingData.education;
                this.content = results[1];
                this.loading = false;
            }
        );
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
        this.subRouter.unsubscribe();
    }

    get educationEntriesCount(): number {
        return this.educationEntries ? this.educationEntries.length : 0;
    }

    get workEntriesCount(): number {
        return this.workEntries ? this.workEntries.length : 0;
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/resume/view/files-view-page.component.ts